import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';

interface UseArtistPlaylistScoreChartParams {
  artistId: string;
  date?: Date;
  rangeDays?: number;
}

export const useArtistPlaylistScoreChart = ({ artistId, date, rangeDays }: UseArtistPlaylistScoreChartParams) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();

  const playlistScoreChartQuery = useTRPCQuery(
    trpcMusicAPI.artists.playlistScoreChart.queryOptions(
      {
        artistId,
        date,
        rangeDays,
        ...shareTokenInput,
      },
      {
        enabled: Boolean(artistId),
      }
    )
  );

  return playlistScoreChartQuery;
};
